import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo } from 'react';
import { Icon24Close } from '@figma/fpl-icons/icon-24-close';
import clsx from 'clsx';
import '../buttons/button.js';
import '../buttons/dialog-trigger-button/dialog-trigger-button.js';
import { IconButton } from '../buttons/icon-button/icon-button.js';
import '../buttons/toggle-button/toggle-button.js';
import { useString } from '../settings/settings.strings.js';
import { variantStyles, typeStyles, getIcon } from './banner.utils.js';
import { BannerContext } from './banner-context.js';
import { iconContainer, content, closeWrapper, root } from './banner.css.js';

/**
 * Root element for Banner. Banner is used to inform or warn the user about important information.
 * @see https://fpl.figma.design/components/banner/
 */
const Root = forwardRef(({ children, onDismiss, dismissAriaLabel, icon, type, variant = 'default', ...props }, ref) => {
    const defaultDismissLabel = useString('dismiss');
    const bannerContextValue = useMemo(() => ({ variant }), [variant]);
    const Icon = getIcon(variant, type);
    return (jsxs("div", { "data-fpl-component": "", ...props, ref: ref, className: clsx(root, variantStyles[variant], typeStyles[type]), children: [icon === null ? null : (jsx("div", { className: iconContainer, children: icon === undefined ? jsx(Icon, { "aria-hidden": true }) : icon })), jsx(BannerContext.Provider, { value: bannerContextValue, children: jsx("div", { className: content, children: children }) }), onDismiss && (jsx("div", { className: closeWrapper, children: jsx(IconButton, { "aria-label": dismissAriaLabel || defaultDismissLabel, onClick: onDismiss, children: jsx(Icon24Close, {}) }) }))] }));
});
Root.displayName = 'Banner.Root';

export { Root };
//# sourceMappingURL=banner-root.js.map
